export default [{
	titulo: 'Categorias',
	icone: 'menu-icon fa fa-caret-right',
	url: '/admin/categorias',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]